import { TimeOffStatus } from './timeoff.types';

export const StatusColorMap: Record<TimeOffStatus, string> = {
  [TimeOffStatus.PENDING]: '#FBC04D' + '4D',
  [TimeOffStatus.APPROVED]: '#00C56C' + '4D',
  [TimeOffStatus.DECLINED]: '#E24545' + '4D',
  [TimeOffStatus.OVERDUE]: '#E24545' + '4D',
};

export const BadgeStatusColorMap: Record<TimeOffStatus, string> = {
  [TimeOffStatus.PENDING]: '#FFF4CC',
  [TimeOffStatus.APPROVED]: '#E9F3EE',
  [TimeOffStatus.DECLINED]: '#FAE4E1',
  [TimeOffStatus.OVERDUE]: '#FAE4E1',
};

export const StatusTextMap: Record<TimeOffStatus, string> = {
  [TimeOffStatus.PENDING]: 'Requested',
  [TimeOffStatus.APPROVED]: 'Approved',
  [TimeOffStatus.DECLINED]: 'Declined',
  [TimeOffStatus.OVERDUE]: 'Overdue',
};
